import { Component, Inject, OnInit, Renderer2, DOCUMENT, ChangeDetectorRef } from '@angular/core';
import { CarouselBannerComponent } from '../../components/carousel-banner/carousel-banner.component';
import { CarouselCardComponent } from '../../components/carousel-card/carousel-card.component';
import { ContentAreaComponent } from '../../components/content-area/content-area.component';
import { TabContent1Component } from '../../components/tab-content1/tab-content1.component';
import { ContentCardComponent } from '../../components/content-card/content-card.component';
import { TabContentComponent } from '../../components/tab-content/tab-content.component';
import { ContentArea2Component } from '../../components/content-area2/content-area2.component';
import { DynamicFormComponent } from '../../components/dynamic-form/dynamic-form.component';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { environment } from '../../../environments/environment';
import { CommonApiService } from '../../services/commonapi.service';
import { CareerForm } from '../../models/career.interface';
import { RedirectionService } from '../../services/redirection.service';

@Component({
    selector: 'app-home',
    imports: [
    CarouselBannerComponent,
    ContentAreaComponent,
    CarouselCardComponent,
    TabContent1Component,
    ContentCardComponent,
    TabContentComponent,
    ContentArea2Component,
    DynamicFormComponent,
    RouterModule
],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
    private metaDataSet = false;
    homeFormConfig: CareerForm | null = null;
    homeFormTitle = '';
    listdata = [
        { listtext: 'A callback from your dedicated wealth partner' },
        { listtext: 'A personalized discussion to understand your needs' },
        { listtext: 'Bespoke recommendations to enable you to achieve your financial goals' },
    ];
    solutionData: any = {
        heading: 'Exclusive Solutions for <u>Your Needs</u>',
        description: '<p>We help create strategies designed to achieve your individual, family, and business goals.</p>',
    };

    constructor(
        private readonly meta: Meta,
        private readonly title: Title,
        private readonly route: ActivatedRoute,
        private readonly renderer: Renderer2,
        @Inject(DOCUMENT) private readonly document: Document,
        private readonly commonApiService: CommonApiService,
        private readonly _redirection: RedirectionService,
        private readonly cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadHomeFormConfig();
        if (!this.metaDataSet) {
            const meta = {
                title: 'Trusted Wealth Management Partner in India | Shriram Wealth',
                description: 'Grow and manage your portfolio with Shriram Wealth, offering trusted investment and wealth management services across India',
                twitter_title: 'Trusted Wealth Management Partner in India | Shriram Wealth',
                twitter_description: 'Grow and manage your portfolio with Shriram Wealth, offering trusted investment and wealth management services across India',
                og_title: 'Trusted Wealth Management Partner in India | Shriram Wealth',
                og_description: 'Grow and manage your portfolio with Shriram Wealth, offering trusted investment and wealth management services across India',
                keywords: 'wealth management, shriram wealth, wealth management solutions, wealth management service, wealth management system, wealth management company',
            };
            this.title.setTitle(meta.title);
            this.meta.updateTag({ name: 'description', content: meta.description });
            this.meta.updateTag({ name: 'twitter:title', content: meta.twitter_title });
            this.meta.updateTag({ name: 'twitter:description', content: meta.twitter_description });
            this.meta.updateTag({ property: 'og:title', content: meta.og_title });
            this.meta.updateTag({ property: 'og:description', content: meta.og_description });
            this.meta.updateTag({ name: 'keywords', content: meta.keywords });

            const head = this.document.getElementsByTagName('head')[0];
            let element: HTMLLinkElement | null = this.document.querySelector(`link[rel='canonical']`) || null;
            if (!element) {
                element = this.document.createElement('link') as HTMLLinkElement;
                head.appendChild(element);
            }
            element.setAttribute('rel', 'canonical');
            element.setAttribute('href', environment.appUrl);
            this.metaDataSet = true;
        }

        const jsonLdData = {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Shriram Wealth',
            url: environment.appUrl,
            logo: environment.appUrl + 'assets/images/wealth-logo.png',
            sameAs: [
                'https://www.facebook.com/profile.php?id=61570845327379',
                'https://x.com/ShriramWealth01',
                'https://www.instagram.com/shriram.wealth/',
                'https://www.linkedin.com/company/shriram-wealth/about/',
            ],
        };
        const scriptElement = this.renderer.createElement('script');
        this.renderer.setAttribute(scriptElement, 'type', 'application/ld+json');
        this.renderer.setProperty(scriptElement, 'innerHTML', JSON.stringify(jsonLdData));
        const existingScript = this.document.querySelector('script[type="application/ld+json"]');
        if (existingScript) {
            this.renderer.removeChild(this.document.head, existingScript);
        }
        this.renderer.appendChild(this.document.head, scriptElement);
    }

    handler_redirect(selectedTab: number) {
        this._redirection.solution.set(selectedTab);
        setTimeout(() => this._redirection.handler_scroll('js-scrollContent'), 500);
    }

    private loadHomeFormConfig(): void {
        if (typeof window === 'undefined') return;
        this.commonApiService.getPageData('home').subscribe({
            next: (res: any) => {
                const formSec = res?.data?.home_form_form_sec;
                if (formSec?.form) {
                    this.homeFormConfig = formSec.form;
                    this.homeFormTitle = formSec.title || '';
                    this.cdr.markForCheck();
                }
            },
            error: (err) => console.error('Failed to load home form config:', err),
        });
    }
}
